<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold" translate="study-editor.import-design.import-file.title"></h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>
    <div class="modal-body">
        @if (isProcessingMapping) {
            <div class="row pt-2">
                <div class="col d-flex justify-content-center align-items-center">
                    <span class="throbber"></span><div class="ps-2">{{ 'study-editor.import-design.import-file.mapping.loading-mapping-data' | translate}}</div>
                </div>
            </div>
        } @else {
            <div class="row pt-2">
                <div class="col"><span class="fw-bold">{{ 'study-editor.import-design.import-file.mapping.heading' | translate | uppercase}}</span></div>
            </div>
            <div class="row pt-2 mb-3">
                <div class="col">
                    <span>{{ 'study-editor.import-design.import-file.mapping.description' | translate}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="alert alert-warning">
                       <i class="fa fa-warning"></i>
                        {{ 'study-editor.import-design.import-file.mapping.mandatory.fields.warning' | translate }}
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <a class="d-block text-decoration-none" data-bs-toggle="collapse" href="#advancedOptions" role="button"
                   aria-expanded="false" aria-controls="advancedOptions">
                    <i class="fas fa-chevron-down me-2"></i><span translate="study-editor.study-dataset.import-study-map.advanced-options"></span>
                </a>
                <div class="collapse" id="advancedOptions">
                    <div class="card card-body bg-light mt-2">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="maintainHeaders"
                                   [(ngModel)]="maintainHeaders">
                            <label class="form-check-label" for="maintainHeaders" translate="study-editor.study-dataset.import-study-map.maintain-naming">
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- Unmapped Items -->
                <div class="col-md-5">
                    <div class="card">
                        <div class="card-header bg-danger bg-opacity-25 text-danger fw-bold d-flex justify-content-between align-items-center">
                            <span>{{'Un-Mapped' | uppercase}}</span>
                            <span class="badge rounded-pill bg-secondary">{{ unmappedItems.length }}</span>
                        </div>
                        <div class="card-body p-0 scrollable-container custom-scroll-style">
                            <div
                                    cdkDropList
                                    #unmappedList="cdkDropList"
                                    [cdkDropListData]="unmappedItems"
                                    [cdkDropListConnectedTo]="[environmentalSection.internalDropList, environmentalSection.internalDropList,
                                treatmentFactorSection.internalDropList, designSection.internalDropList, germplasmSection.internalDropList,
                                traitsSection.internalDropList, entryDetailsSection.internalDropList]"
                                    id="unmapped"
                                    class="list-group list-group-flush drag-container"
                                    (cdkDropListDropped)="drop($event)">
                                <div
                                        class="list-group-item"
                                        *ngFor="let item of unmappedItems"
                                        cdkDrag>
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-7">
                    <div class="container-fluid scrollable-container-main  custom-scroll-style">
                        <!-- Environmental Factors -->
                        <div class="mb-3">
                            <jhi-map-section #environmentalSection groupName="{{'study-editor.import-design.import-file.mapping.group.environmental-factors' | translate}}"
                                             [mapItems]="environmentalFactors"
                                             [connectedLists]="[unmappedList, treatmentFactorSection.internalDropList, designSection.internalDropList, germplasmSection.internalDropList, traitsSection.internalDropList, entryDetailsSection.internalDropList]"
                                             [drop]="drop" (remapItem)="remapItem($event, environmentalFactors, [VariableTypeEnum.ENVIRONMENT_CONDITION, VariableTypeEnum.ENVIRONMENT_DETAIL])"></jhi-map-section>
                        </div>
						<div class="mb-3">
							<jhi-map-section #treatmentFactorSection groupName="{{'study-editor.import-design.import-file.mapping.group.treatment-factors' | translate}}" [mapItems]="treatmentFactors"
											 [connectedLists]="[unmappedList, designSection.internalDropList, environmentalSection.internalDropList, germplasmSection.internalDropList, traitsSection.internalDropList, entryDetailsSection.internalDropList]"
											 [drop]="drop" (remapItem)="remapItem($event, treatmentFactors, [VariableTypeEnum.TREATMENT_FACTOR])"></jhi-map-section>
						</div>
                        <div class="mb-3">
                            <jhi-map-section #designSection groupName="{{'study-editor.import-design.import-file.mapping.group.design-factors' | translate}}" [mapItems]="designFactors"
                                             [connectedLists]="[unmappedList, treatmentFactorSection.internalDropList, environmentalSection.internalDropList, germplasmSection.internalDropList, traitsSection.internalDropList, entryDetailsSection.internalDropList]"
                                             [drop]="drop" (remapItem)="remapItem($event, designFactors, [VariableTypeEnum.EXPERIMENTAL_DESIGN])"></jhi-map-section>
                        </div>
                        <div class="mb-3">
                            <jhi-map-section #entryDetailsSection groupName="{{'study-editor.import-design.import-file.mapping.group.entry-details' | translate}}" [mapItems]="entryDetails"
                                             [connectedLists]="[unmappedList, environmentalSection.internalDropList, treatmentFactorSection.internalDropList, designSection.internalDropList, germplasmSection.internalDropList, traitsSection.internalDropList]"
                                             [drop]="drop" (remapItem)="remapItem($event, entryDetails, [VariableTypeEnum.ENTRY_DETAIL])"></jhi-map-section>
                        </div>
                        <div class="mb-3">
                            <jhi-map-section #germplasmSection groupName="{{'study-editor.import-design.import-file.mapping.group.germplasm-factors' | translate}}" [mapItems]="germplasmFactors"
                                             [connectedLists]="[unmappedList, environmentalSection.internalDropList, treatmentFactorSection.internalDropList, designSection.internalDropList, traitsSection.internalDropList, entryDetailsSection.internalDropList]"
                                             [drop]="drop" (remapItem)="remapItem($event, germplasmFactors, [VariableTypeEnum.GERMPLASM_DESCRIPTOR])"></jhi-map-section>
                        </div>
                        <div class="mb-3">
                            <jhi-map-section #traitsSection groupName="{{'study-editor.import-design.import-file.mapping.group.traits' | translate}}" [mapItems]="traits"
                                             [connectedLists]="[unmappedList, environmentalSection.internalDropList, treatmentFactorSection.internalDropList, designSection.internalDropList, germplasmSection.internalDropList, entryDetailsSection.internalDropList]"
                                             [drop]="drop" (remapItem)="remapItem($event, traits, [VariableTypeEnum.TRAIT, VariableTypeEnum.SELECTION_METHOD])"></jhi-map-section>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <div class="row mb-3">
            <div class="col d-flex justify-content-end">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel()">
                    <span translate="cancel"></span>
                </button>
                <button class="btn btn-primary ms-2" (click)="saveMapping()">
                    <span translate="next"></span>
                </button>
            </div>
        </div>
    </div>
</div>
